import { render, staticRenderFns } from "./PanelInfo.vue?vue&type=template&id=7b319562&scoped=true&"
import script from "./PanelInfo.vue?vue&type=script&lang=ts&"
export * from "./PanelInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PanelInfo.vue?vue&type=style&index=0&id=7b319562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b319562",
  null
  
)

export default component.exports